import moment from "moment"
import { memo } from "react"
import { Link } from "react-router-dom"
import { FormGroup, Input, Label } from "reactstrap"
import { MaterialIcon } from "./styles"
import './style.scss';


const MailList = (props: any) => {
  return (
    <div className="col-md-12 col-lg-12 " id={props?.data?.id}>
      <div className={`bg-white text-dark border-bottom border-light `}>
        <div className={`p-2 ${props?.data?.isRead === false && 'is-read'}`}>
          <div className="d-flex flex-start">
            <FormGroup className="pe-4">
              <Input
                id={props?.data?.id}
                type="checkbox"
                onChange={()=>props?.handleChecked(props?.data?.id)}
                checked={props?.data?.checked}
              />
              {' '}
              <Label for={props?.data?.id}>
              </Label>
            </FormGroup>
            <div className="flex-grow-1">
              <Link to={`./${props?.data?.id}`} className="link-muted  "><h6 className={`mb-1  ${props?.data?.isRead === false ? 'text-dark fw-bold':'text-primary'}`}>{props?.data?.sender?.emailAddress?.name}</h6></Link>
              <Link to={`./${props?.data?.id}`} className={`link-muted ${props?.data?.isRead === false ? 'text-primary fw-bold':'text-dark'}`}>
                {props?.data?.subject ? <p className="mb-0" dangerouslySetInnerHTML={{
                  __html: props?.data?.subject,
                }}>
                </p> : <p>(No Subject)</p>}
              </Link>
              <Link to={`./${props?.data?.id}`} className="text-dark link-muted fw-light">
                <p className="mb-0" dangerouslySetInnerHTML={{
                  __html: props?.data?.bodyPreview,
                }}>
                </p>
              </Link>
            </div>
            <div className="ms-auto" style={{width:'145px'}}>
              <div className="align-items-center text-end mb-1">
                {props?.data?.hasAttachments && <MaterialIcon>attach_file</MaterialIcon>}
                <p className="mb-0">
                  {moment(props?.data?.receivedDateTime).format('MMM Do YY')}
                  {/* <span className="badge bg-primary">Pending</span> */}
                </p>
                {/* <Button color="link"><MaterialIcon>reply</MaterialIcon></Button> */}
                {/* <a href="#!" className="link-muted"><i className="fas fa-redo-alt ms-2"></i></a>
                                    <a href="#!" className="link-muted"><i className="fas fa-heart ms-2"></i></a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(MailList);